import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const [videoSrc, setVideoSrc] = useState('');

  // Video files in public/videos folder
  const videos = [
    '/videos/1.mp4',
    '/videos/3.mp4',
    '/videos/4.mp4',
    '/videos/406bbq.mp4',
    '/videos/aldentediva.mp4',
    '/videos/alexrioscooks.mp4',
    '/videos/allenxspeigner.mp4',
    '/videos/atlchefd.mp4',
    '/videos/bamagrillmaster.mp4',
    '/videos/bartalkbruno.mp4',
    '/videos/bigpaulonthegrill.mp4',
    '/videos/castingandcooking.mp4',
    '/videos/chilipeppercooks.mp4',
    '/videos/chucksflavortrain.mp4',
    '/videos/cibsandibus.mp4',
    '/videos/cookingwithkatiecross.mp4',
    '/videos/cookingwithmrcooper.mp4',
    '/videos/cookingwithryam.mp4',
    '/videos/cptnron302.mp4',
    '/videos/deborahruiz.mp4',
    '/videos/devontewest.mp4',
    '/videos/diana-ruiz.mp4',
    '/videos/fooddudescook.mp4',
    '/videos/gigi-eats.mp4',
    '/videos/girlgonegrilling.mp4',
    '/videos/jaredbuccii.mp4',
    '/videos/keefandjess.mp4',
    '/videos/king-cooks.mp4',
    '/videos/kyleistook.mp4',
    '/videos/meatdad.mp4',
    '/videos/meatlicious.mp4',
    '/videos/noah-nator.mp4',
    '/videos/pattypopculture.mp4',
    '/videos/red-gods.mp4',
    '/videos/richard-eats.mp4',
    '/videos/rick-carly.mp4',
    '/videos/southervibin.mp4',
    '/videos/theflavors.mp4',
    '/videos/tolers.mp4',
  ];

  useEffect(() => {
    // Randomly select a video on component mount
    const randomVideo = videos[Math.floor(Math.random() * videos.length)];
    setVideoSrc(randomVideo);
  }, []);

  const services = [
    {
      title: 'Talent Representation',
      desc: 'Our dedicated team provides personalized guidance, strategic direction, and exclusive opportunities designed to elevate talent and unlock their full potential. By building meaningful partnerships and navigating the industry with precision, we empower creators to grow, shine, and achieve lasting success.'
    },
    {
      title: 'Campaign Management',
      desc: 'We specialize in managing every stage of creator-driven campaigns, from initial strategy and concept development to flawless execution and performance tracking. Our team ensures each collaboration runs seamlessly, aligning creative vision with measurable results while maximizing impact and engagement across platforms.'
    },
    {
      title: 'Brand Sourcing',
      desc: 'Our expertise lies in identifying and securing high-value opportunities through targeted, strategic outreach. Leveraging our expansive network and deep industry knowledge, we connect talent with campaigns and partnerships that maximize earning potential, drive sustainable growth, and position creators for long-term success in the ever-evolving digital landscape.'
    }
  ];

  return (
    <div className="home">
      {/* Video Background */}
      <div className="video-container">
        <div className="video-overlay"></div>
        {videoSrc && (
          <video
            autoPlay
            muted
            loop
            playsInline
            className="background-video"
            key={videoSrc}
          >
            <source src={videoSrc} type={videoSrc.endsWith('.mov') ? 'video/quicktime' : 'video/mp4'} />
          </video>
        )}
      </div>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            <span className="title-line">Powering Meaningful</span>
            <span className="title-line">Partnerships Between</span>
            <span style={{ display: 'flex', flexDirection: 'row' }}>
              <span className="title-line accent">Talent</span>
              <span className="title-line">&nbsp;and&nbsp;</span>
              <span className="title-line accent">Brands</span></span>
          </h1>
          <p className="hero-description">
            Alooma is your destination for top-tier culinary, lifestyle and entertainment talent.
            As a full-service talent management agency, we leverage our extensive network
            to connect our clients with brands, delivering strategic, results-driven
            partnerships that grow and endure.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn-primary">
              <span>Contact Us</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
            <Link to="/talent" className="btn-secondary">For Talent</Link>
          </div>
        </div>

        <div className="scroll-indicator">
          <span className="scroll-text">Scroll</span>
          <div className="scroll-line">
            <div className="scroll-dot"></div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-container">
          <span className="section-label">Our Services</span>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
